import styled, { css } from "styled-components";
import { Row, Col, Card } from "react-bootstrap";
import { Collapse, Tooltip, Menu, Dropdown } from "antd";

interface Props {
  mainTitle?: boolean;
  collectionDesc?: boolean;
  isMainSell?: boolean;
}

export const NftDetailsWrapper = styled.div``;

export const PriceCardMain = styled.div<Props>`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;

  ${(props) =>
    props.collectionDesc &&
    css`
      justify-content: start;
    `}
  @media (max-width: 960px) {
    display: flex;
    flex-direction: column;
  }
`;
export const CardEthIcon = styled.img`
  /* margin-top: 2rem;  */
`;

export const NftPropertiesTitle = styled.p`
  text-align: center;
  color: rgb(255, 255, 255);
  padding-top: 0.3rem;
  font-weight: bold;
`;
export const NftPropertiesDesc = styled.p`
  text-align: center;
  margin-top: 0rem;
  font-weight: 600;
  color: white;
`;
export const NftPropertiesDesc2 = styled.p`
  text-align: center;
  margin-top: -0.6rem;
`;

//NftPropertiesCard

// About
export const NftDetailsAbout = styled.span`
  display: inline-block;
`;
export const NftAboutImg = styled.img`
  border-radius: 10px;
  height: 100%;
  object-fit: contain;
  transition: opacity 400ms ease 0s;
  width: 100%;
`;
export const AboutImgDiv = styled.div`
  float: left;
  margin-right: 10px;
  margin-top: 3px;
  height: 80px;
  width: 80px;
  border-radius: 10px;
  height: 100%;
  width: 80px;
`;

// Social Dropdown

// socialIcons

// About

// Details
export const DeatilsTitle = styled.p``;
export const DeatilsValue = styled.p`
  text-align: end;
  font-weight: 600;
  color: #000;
`;

// Details

export const NftDetailDesc = styled.div`
  /* height: 100px;
  overflow: auto; */
  padding: 0.8rem 1rem;
  margin-top: -1.2rem;
`;
export const NftDescTitle = styled.p`
  padding: 0.5rem 1rem;
  margin-top: 1rem;

  & span {
    color: #2081e2;
  }
`;
export const NftToolTip = styled(Tooltip)`
  &:hover {
    cursor: pointer;
  }
`;

export const CollectionTitles = styled.h2<Props>`
  margin-top: 2rem;
  color: black;
  margin-left: 1.8rem;
  ${(props) =>
    props.mainTitle &&
    css`
      font-size: 1rem;
    `}
  @media (max-width:767px) {
    text-align: center;
  }
`;
export const Collectiondesc = styled.p`
  margin-top: 2rem;
  color: black;
  margin-left: 1.8rem;
  @media (max-width: 767px) {
    text-align: center !important;
  }
`;
export const Collectionfavourite = styled.p`
  margin-top: 2rem;
  color: black;
  @media (max-width: 767px) {
    text-align: center !important;
  }
`;

export const CollapseHeader = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-top: -0.5rem;
`;

export const CollapseHeaderTitle = styled.p`
  transform: translateY(7px);
  font-weight: 600;
`;

export const MainSell = styled.div<Props>`
  position: fixed;

  z-index: 5;
  width: 100%;
  margin-right: 2rem;
  padding: 1.5rem;
  background: #e67e22;

  ${(props) =>
    props.isMainSell &&
    css`
      top: 0;
      transition: cubic-bezier(0.075, 0.82, 0.165, 1);
    `}
`;
